export default (locale) => {
  switch (locale) {
    case 'sr-Latn':
    case 'sr':
      return import(/* webpackChunkName: "i18n.common.sr-Latn" */ './sr-Latn');
    case 'ro':
      return import(/* webpackChunkName: "i18n.common.ro" */ './ro');
    case 'pt':
    case 'pt-br':
    case 'pt-BR':
      return import(/* webpackChunkName: "i18n.common.pt-br" */ './pt-br');
    default:
      return import(/* webpackChunkName: "i18n.common" */ './en');
  }
};
